import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {Helmet} from 'react-helmet';
import ReactHtmlParser from 'react-html-parser';
import moment from 'moment';
import 'moment/min/locales';
import 'moment/locale/fr';
import Link from "react-router-dom/Link";
import Button from "@material-ui/core/Button/Button";
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import {withLocalize, Translate} from 'react-localize-redux';
import translations from '../../translations/translations_news_details';

class NewsDetails extends Component {
    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    render() {
        const {news} = this.props;

        moment.locale('fr');

        let idArticle = 'news-' + news.id;

        let title = news.title;
        if (news.title_html !== '' && news.title_html !== null) {
            title = ReactHtmlParser(news.title_html);
        }

        return (
            <article id={idArticle} className="news">
                <header>
                    <div className="row">
                        <div className="col col-9">
                            <Button size="medium" className="btnBack" component={props => <Link to={this.props.translate('routes.news')} {...props}/>}>
                                <KeyboardBackspaceIcon className="btnIcon" />
                                <Translate id="news_details.button_back" />
                            </Button>

                            <h1>{title}</h1>
                        </div>
                    </div>
                </header>
                <div className="row row-content">
                    <div className="col col-12">
                        <div className="content-inner">
                            {ReactHtmlParser(news.content)}
                        </div>
                    </div>
                </div>
            </article>
        );
    }
}

NewsDetails.propTypes = {
    news: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
};

export default withLocalize(NewsDetails);



// WEBPACK FOOTER //
// ./src/features/News/components/Details/NewsDetails.js